module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-2-ff8531fa72d513c4c3e2aa3c54b3fb63.svg";